import { render } from "./CreateTimeSlot.vue?vue&type=template&id=d2bb4eac&ts=true"
import script from "./CreateTimeSlot.vue?vue&type=script&lang=ts"
export * from "./CreateTimeSlot.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__